import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'

export const TrailerEnrolledPauseScreen = ({
  onClickBack,
}: {
  onClickBack: () => void
}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div
      className='position-absolute d-flex flex-column justify-content-center align-items-center c-text-color--light'
      style={{ inset: 0, background: 'rgba(var(--c-beige-1400-rgb), 0.9)' }}
    >
      <TrackClick event='certificateLandingClick'>
        <Button
          kind='tertiary'
          className='c-text-color--light'
          onClick={onClickBack}
        >
          {t('marketingPages.comingSoonTrailer.back')}
        </Button>
      </TrackClick>
    </div>
  )
}
